namespace RioERP.Reports {
    export interface OrderShippingForm {
        OrderId: Serenity.IntegerEditor;
        ShippingProviderId: Serenity.LookupEditor;
        EStatus: Serenity.IntegerEditor;
        TrackingId: Serenity.StringEditor;
        TrackingUrl: Serenity.StringEditor;
        ShippingCost: Serenity.IntegerEditor;
        IsActive: Serenity.BooleanEditor;
        ShippingDate: Serenity.DateEditor;
    }

    export class OrderShippingForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.OrderShipping';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderShippingForm.init)  {
                OrderShippingForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.DateEditor;

                Q.initFormType(OrderShippingForm, [
                    'OrderId', w0,
                    'ShippingProviderId', w1,
                    'EStatus', w0,
                    'TrackingId', w2,
                    'TrackingUrl', w2,
                    'ShippingCost', w0,
                    'IsActive', w3,
                    'ShippingDate', w4
                ]);
            }
        }
    }
}
